<template>
  <section>
    <div v-if="turma" class="frame fixed" ref="turmaForm">
      <div class="row no-padd" >
        <div class="col-md-4 form-group">
          <label>Unidade</label>
          <select-control 
            v-model="turma.idUnidade" 
            name="idUnidade" 
            :options="options.unidades" 
            placeholder="Selecione" 
            @change="onUnidadeChange(); valid.idUnidade = true"
            :disabled="loading"
            :valid="valid.idUnidade" 
            required
          />
        </div>
        <div class="col-md-4 form-group">
          <label>Turno</label>
          <select-control 
            v-model="turma.idTurno" 
            :options="options.turnos" 
            placeholder="Selecione" 
            name="idTurno"
            :disabled="loading"
            :valid="valid.idTurno" 
            @change="valid.idTurno = true"
            required
          />
        </div>
        <div class="col-md-4 form-group">
          <label>Tipo de Curso</label>
          <select-control 
            v-model="tipoCurso" 
            name="tipoCurso" 
            :options="options.tipoCurso" 
            placeholder="Selecione" 
            :disabled="loading" 
            @change="
              onTipoCursoChange();
              valid.tipoCurso = true
            "
            :valid="valid.tipoCurso" 
            required
          />
        </div>
        <div class="col-md-4 form-group">
          <label>Período Letivo</label>
          <select-control 
            v-model="turma.idPeriodoLetivo" 
            :options="options.periodosLetivos" 
            placeholder="Selecione" 
            name="idPeriodoLetivo"
            @change="
              onPeriodoLetivoChange();
              valid.idPeriodoLetivo = true
            " 
            :disabled="loading"
            :valid="valid.idPeriodoLetivo" 
            required
          />
        </div>
        <div class="col-md-4 form-group">
          <label>Curso</label>
          <select-control 
            v-model="turma.idCurso" 
            :options="options.cursos" 
            placeholder="Selecione" 
            name="idCurso"
            :disabled="loading" 
            @change="
              onCursoChange();
              valid.idCurso = true
            "
            :valid="valid.idCurso" 
            required
          />
        </div>
        <div class="col-md-4 form-group">
          <label>Série</label>
          <select-control 
            v-model="turma.idSerie" 
            :options="options.series" 
            placeholder="Selecione" 
            name="idSerie"
            :disabled="loading"
            :valid="valid.idSerie" 
            @change="valid.idSerie = true"
            required
          />
        </div>
      </div>
      <div class="row no-padd">
        <div class="col-md-4 form-group">
          <label>Descrição</label>
          <input-control
            v-model="turma.descricao" 
            placeholder="" 
            name="descricao"
            type="text"
            :valid="valid.descricao" 
            @keyup="valid.descricao = true"
            required
          />
        </div>
        <div class="col-md-6 form-group">
          <label>Detalhes</label>
          <input-control
            v-model="turma.detalhes" 
            placeholder="" 
            name="descricao"
            type="text"
            :valid="valid.detalhes" 
          />
        </div>
      </div>
      <div class="row no-padd">
        <div class="col-md-2 form-group">
          <label>Data Início</label>
          <input-control
            v-model="turma.dataInicio" 
            placeholder="" 
            name="dataInicio"
            type="date"
          />
        </div>
        <div class="col-md-2 form-group">
          <label>Data Final</label>
          <input-control
            v-model="turma.dataFinal" 
            placeholder="" 
            name="dataFinal"
            type="date"
          />
        </div>
        <div class="col-md-2 form-group">
          <label>Capacidade</label>
          <input-control
            v-model="turma.capacidade" 
            placeholder="" 
            name="capacidade"
            type="number"
            :valid="valid.capacidade" 
            @keyup="valid.capacidade = true"
            required
          />
        </div>
        <!-- <div class="col-md-3 form-group checks">
          <label class="check-control super">
            <input type="checkbox" class="check" v-model="turma.itinerario"/>
            <span>Itinerário</span>
          </label>
        </div> -->
        <!-- <div class="col-md-2 form-group">
          <label>Vagas</label>
          <input-control
            v-model="turma.vagas" 
            placeholder=""
            name="vagas"
            type="number"
            :valid="valid.vagas" 
            @keyup="valid.vagas = true"
            required
          />
        </div> -->
        <!-- <div class="col-md-2 form-group">
          <label>Meta de Ocupação</label>
          <input-control
            v-model="turma.ocupacaoMeta" 
            placeholder=""
            name="ocupacaoMeta"
            type="number"
          />
        </div> -->
      </div>
      <div class="row no-padd">
        <div class="col-md-12 form-actions form-group">
          <button type="button" @click="save()" class="btn btn-primary" :disabled="loading">
            {{ loading ? 'Salvando...' : (isEditing ? 'Salvar e sincronizar' : 'Criar e sincronizar') }}
          </button>
          <button type="button" @click="cancel()" class="btn btn-secondary" :disabled="loading">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UserService from '@/services/user.service.js'
import AcademicoService from '@/services/academico.service.js'
import { createSelectOptions } from '@/services/utils.service.js'
import FormService from '@/services/form.service.js'

export default {
  props: {
    scope: {
      type: Object
    }
  },
  data () {
    return {
      turma: null,
      valid: {
        descricao: true,
        capacidade: true,
        idUnidade: true,
        idTurno: true,
        idPeriodoLetivo: true,
        idCurso: true,
        idSerie: true,
        tipoCurso: true
      },
      wait: {
        unidades: false,
        turnos: false,
        cursos: false,
        tipoCurso: false
      },
      options: {
        unidades: [],
        turnos: [],
        tipoCurso: [],
        periodosLetivos: [],
        series: [],
        turmas: [],
        cursos: [],
      },
      tipoCurso: null,
      cursos: [],
      series: [],
      loading: false
    }
  },
  computed: {
    isEditing () {
      return Boolean(this.turma?.idTurma)
    }
  },
  mounted () {
    this.turma = { ...this.scope }
    Promise.all([
      this.getUnidades(),
      this.getTipoCurso(),
      this.getCursos(),
      this.getTurnos()
    ]).then(() => this.initializeEditingOptions())
  },
  methods: {
    initializeEditingOptions () {
      if ( !this.isEditing ) {
        return
      }

      const curso = this.cursos.find(item => item.idCurso == this.turma.idCurso)
      this.tipoCurso = curso?.idTipoCurso || null
      this.selectTipoCurso()

      return Promise.all([
        this.getPeriodosLetivos(),
        this.getSeries()
      ])
    },
    getUnidades () {
      return UserService.getMinhasUnidades().then(
        response => {
          console.log("getMinhasUnidades:", response.data)
          this.options.series = []
          this.options.periodosLetivos = []
          
          if ( response.data.length > 0 ) {
            this.options.unidades = createSelectOptions(response.data, 'idUnidade' ,'descricao')
            this.wait.unidades = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhuma unidade encontrada. Verifique sua conexão e tente novamente.", floater: true})
          }
          
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma unidade encontrada. Verifique sua conexão e tente novamente.", floater: true})
        }
      )
    },
    getTurnos () {
      return AcademicoService.getTurnos().then(
        response => {
          console.log("getTurnos:", response.data)
          if ( response.data.length > 0 ) {
            this.options.turnos = createSelectOptions(response.data, 'idTurno' ,'descricao')
            this.wait.turnos = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum tipo de curso encontrado. Verifique sua conexão e tente novamente.", floater: true})
          }
          
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum tipo de curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getCursos () {
      return AcademicoService.getCursos().then(
        response => {
          console.log("getCursos:", response.data)
          if ( response.data.length > 0 ) {
            this.cursos = response.data
            this.options.cursos = createSelectOptions(response.data, 'idCurso' ,'descricao')
            this.wait.cursos = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
          }

         
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getTipoCurso () {
      return AcademicoService.getTipoCurso().then(
        response => {
          console.log("getTipoCurso:", response.data)
          if ( response.data.length > 0 ) {
            this.options.tipoCurso = createSelectOptions(response.data, 'idTipoCurso' ,'descricao')
            this.wait.tipoCurso = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum tipo de curso encontrado. Verifique sua conexão e tente novamente.", floater: true})
          }
          
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum tipo de curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getPeriodosLetivos () {
      this.loading = true
      return AcademicoService.getPeriodosLetivos(this.turma.idUnidade).then(
        response => {
          console.log("getPeriodosLetivos:", response.data)
          
          if ( response.data.length > 0 ) {
            this.options.periodosLetivos = createSelectOptions(response.data, 'idPeriodoLetivo' ,'descricao').reverse()
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum período letivo encontrado para esta unidade. Isto parece ser um problema de parametrização.", floater: true})
          }
          this.loading = false
        },
        error => {
          console.error(error)
          this.loading = false
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum período letivo encontrado para esta unidade. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getSeries () {
      this.loading = true
      // const tipoCurso = 
      return AcademicoService.getSeries(this.turma.idPeriodoLetivo, this.tipoCurso).then(
        response => {
          console.log("getSeries:", response.data)
          this.options.series = []

          if ( response.data.length > 0 ) {
            this.series = response.data
            response.data.map( k => {
              k.label = k.descricao + ' ' + k.descricaoTurno
            })
            this.options.series = createSelectOptions(response.data, 'idSerie' ,'label')
            if ( this.turma.idCurso ) {
              this.selectCurso()
            }
            
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhuma série encontrada para este período letivo. Isto parece ser um problema de parametrização.", floater: true})
          }

          this.loading = false
        },
        error => {
          console.error(error)
          this.loading = false
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma série encontrada para este período letivo. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    selectTipoCurso () {
      const selected = this.tipoCurso
      this.loading = true

      if ( !selected ) {
        this.options.cursos = createSelectOptions(this.cursos, 'idCurso', 'descricao')
        this.loading = false
        return
      }
      
      const result = this.cursos.filter( k => {
        return k.idTipoCurso == selected
      })
      
      if ( result.length > 0 ) {
        this.options.cursos = createSelectOptions(result, 'idCurso' ,'descricao')
      } else {
        this.options.cursos = []
      }
      this.loading = false
    },
    finishLoad () {
      const finished = !Object.values(this.wait).some( a => !a)

      if ( finished ) {
        window.spinner.emit("close")
        this.loading = false
      }
      // console.log("finished:", finished)

    },
    selectCurso () {
      const selected = this.turma.idCurso
      this.loading = true

      if ( !selected ) {
        this.options.series = createSelectOptions(this.series, 'idSerie', 'label')
        this.loading = false
        return
      }
      
      const result = this.series.filter( k => {
        return k.idCurso == selected
      })

      if ( result.length > 0 ) {
        this.options.series = createSelectOptions(result, 'idSerie' ,'label')
      } else {
        this.options.series = []
      }
      this.loading = false
    },
    clearFilter ( part ) {
      if ( part === 'tipoCurso' ) {
        this.turma.idCurso = null
        this.turma.idSerie = null
        this.options.series = []
      } else if ( part === 'periodoLetivo' ) {
        this.turma.idSerie = null
        this.options.series = []
      } else if ( part === 'curso' ) {
        this.turma.idSerie = null
        this.options.series = createSelectOptions(this.series, 'idSerie', 'label')
      }

    },
    onUnidadeChange () {
      this.turma.idPeriodoLetivo = null
      this.turma.idSerie = null
      this.options.periodosLetivos = []
      this.options.series = []
      if ( this.turma.idUnidade ) {
        this.getPeriodosLetivos()
      }
    },
    onTipoCursoChange () {
      this.clearFilter('tipoCurso')
      this.selectTipoCurso()
      if ( this.turma.idPeriodoLetivo ) {
        this.getSeries()
      }
    },
    onPeriodoLetivoChange () {
      this.clearFilter('periodoLetivo')
      if ( this.turma.idPeriodoLetivo ) {
        this.getSeries()
      }
    },
    onCursoChange () {
      this.clearFilter('curso')
      this.selectCurso()
    },
    save () {
      if ( this.loading ) {
        return
      }

      const valid = FormService.validate(this.$refs.turmaForm, this.valid)

      if ( valid.response ) {
        this.loading = true
        window.spinner.emit('open')
        const request = this.isEditing
          ? AcademicoService.saveTurmas([this.turma], 1)
          : AcademicoService.saveTurma(this.turma, 1)

        request.then(
          response => {
            if ( response.data.success ) {
              window.toaster.emit('open', {style: "success", message: response.data.message || "Turma salva e sincronizada com sucesso.", floater: true})
              this.$emit('onSave', response.data.results?.[0] || null)
            } else {
              window.toaster.emit('open', {style: "error", message: response.data.message || "Não foi possível sincronizar a turma.", floater: true})
            }
          },
          error => {
            const message = error.response?.data?.message || "Não foi possível salvar e sincronizar a turma informada."
            window.toaster.emit('open', {style: "error", message, floater: true})
          }
        ).finally(() => {
            this.loading = false
            window.spinner.emit('close')
        })
      }
    },
    cancel () {
      this.$emit('onCancel')
    }
  }
}
</script>

<style lang="scss" scoped>
  // .frame {
  //   padding: 0 $hmg_small
  // }

  .form-actions {
    margin-top: $hmg !important
  }
</style>
